import { render } from "./InactivarCodigosTramite.vue?vue&type=template&id=c5666a12&scoped=true"
import script from "./InactivarCodigosTramite.vue?vue&type=script&lang=js"
export * from "./InactivarCodigosTramite.vue?vue&type=script&lang=js"

import "./InactivarCodigosTramite.vue?vue&type=style&index=0&id=c5666a12&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5666a12"]])

export default __exports__